var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66964 0.877809C4.12289 0.524512 3.46617 0.417731 2.85019 0.563137L13.6751 11.3881L17.1835 7.87972L4.66964 0.877809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50666 1.44287C1.20474 1.84426 1.03098 2.33711 1.03098 2.85845V22.1409C1.03098 22.6622 1.20479 23.155 1.50666 23.5564L12.5634 12.4997L1.50666 1.44287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7622 10.4416L18.6091 8.67737L14.7867 12.4997L18.6093 16.3223L21.7627 14.5579C22.5182 14.1347 22.9692 13.3653 22.9692 12.4997C22.9692 11.6342 22.5182 10.8649 21.7622 10.4416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.675 13.6115L2.85074 24.4357C3.02821 24.4775 3.20882 24.5 3.38943 24.5C3.83577 24.5 4.28057 24.3731 4.66958 24.1217L17.1836 17.1199L13.675 13.6115Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.540407fb0d024ee28f070b560f653a69.svg";
export { ForwardRef as ReactComponent };